'use strict';

var isProduction = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

module.exports = warning;



/*****************
 ** WEBPACK FOOTER
 ** ./~/tiny-warning/dist/tiny-warning.cjs.js
 ** module id = 66
 ** module chunks = 0
 **/